import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import InputGroup from "react-bootstrap/InputGroup";
import {connect} from "react-redux";
import React, {useCallback, useEffect, useRef, useState} from "react";
import LoaderService from "../../RetroAssets.System/LoaderService";
import {alert, confirm} from "devextreme/ui/dialog";
import apiClient from "../../services/axios";
import {useNavigate} from "react-router-dom";
import cl from "../../RetroAssets.System/Utilities";
import {TextBox} from "devextreme-react";
import store from 'store'
import {onExcelExporting} from "../../RetroAssets.System/CellRenderImage";
import TransactionsComponent from "../../RetroAssets.System/Components/TransactionsComponent";
import AutoGenerateTransactions from "../Popups/AutoGenerateTransactions";

const mapStateToProps = ({settings}) => ({
    dispatch: settings.dispatch,
});

const BankLoanTransactions = (props) => {
    const navigate = useNavigate();
    const [newItemIndex, setNewItemIndex] = useState(0)
    const pageSettings = JSON.parse(store.get("SettingsForBankLoanTransactions"))

    const spanString = "BankLoan_Transactions"
    const gridInstance = useRef(null)
    const searchRef = useRef(null)
    const [transactionData, setTransactionData] = useState([])
    const [transactionColumns, setTransactionColumns] = useState([])
    const [gridCustomization, setGridCustomization] = useState({})
    const [editedData, setEditedData] = useState([]);
    const [deletedTransactions, setDeletedTransactions] = useState([]);
    const [readOnly, setReadOnly] = useState(true)
    const [changesMade, setChangesMade] = useState(false)
    const [autoGenerateTransactionSettings, setAutoGenerateTransactionSettings] = useState({
        show: false
    })

    const [allTaxes, setAllTaxes] = useState([])

    useEffect(() => {
        getData()
    }, [])

    function getData(showToast) {
        setReadOnly(true)
        LoaderService.setData(true)
        let params = new URLSearchParams({
            externalId: pageSettings["externalId"],
        })
        apiClient
            .get('/BankLoan/GetAllBankLoanTransactions?' + params)
            .then(response => {
                try {
                    let data = JSON.parse(response.data)
                    setTransactionData(data[0]['Data'])
                    let settings = data[1]["Settings"]
                    let cols = settings[0][spanString][0]['Columns']
                    let index = cols.findIndex(x => x["dataField"] === "Tax")
                    if (index > -1) {
                        setAllTaxes(cols[index]["lookup"]["dataSource"])
                    }
                    setTransactionColumns(cols)
                    let gc = settings[0][spanString][3]['GridCustomization'][0]
                    setGridCustomization(cl.enableDisableDataGridEditing(gc, null))
                    if (showToast)
                        cl.showSuccessToast()
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    //#region Purchase Payment

    const deleteTransaction = useCallback((e) => {
        if (e.row.data["Paid"])
            return alert("Cannot delete completed transactions.", "Warning!")

        confirm("Are you sure you wish to delete?", "Warning!").then(resp => {
            if (resp) {
                let index = editedData.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    editedData.splice(index, 1)
                    setEditedData(editedData)
                }

                index = transactionData.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    transactionData.splice(index, 1)
                    gridInstance.current.instance().option("dataSource", transactionData)
                    setTransactionData(transactionData)
                }
                gridInstance.current.instance().repaint()
                setChangesMade(true)
                if (e.row.key.includes("NNNN")) return
                deletedTransactions.push(e.row.key)
                setDeletedTransactions(deletedTransactions)
            }
        })
    }, [editedData, deletedTransactions, transactionData])

    const addTransaction = () => {
        if (pageSettings["Completed"]) return alert("Cannot add transactions once the bank loan is marked as completed.", "Warning!")

        if (readOnly) {
            return alert("Please enable editing to add a new record.", "Warning!");
        }
        gridInstance.current.instance().addRow()
    }

    const clearFilter = () => {
        gridInstance.current?.instance().clearFilter()
        gridInstance.current?.instance().searchByText('')
        searchRef.current?.instance().option('value', null)
    }

    const searchTransactionByText = e => {
        if (!e.event) return
        gridInstance.current?.instance().searchByText(e.value ? e.value : null)
    }

    const rowValidating = e => {
        if (e.newData.hasOwnProperty("Amount") || e.newData.hasOwnProperty("PrincipalAmount")) {
            let amount = e.newData["Amount"] ?? e.oldData["Amount"] ?? 0
            let principalAmount = e.newData["PrincipalAmount"] ?? e.oldData["PrincipalAmount"] ?? 0
            e.newData["Total"] = amount + principalAmount
        }
        setEditedData(cl.rowValidatingEvent(e, editedData))
        setChangesMade(true)
    }

    const initRow = useCallback(e => {
        e.data["externalId"] = "NNNN" + newItemIndex;
        e.data["ID"] = "NNNN"
        e.data["Flag_Loan"] = true
        e.data["Currency"] = pageSettings["CurrencyExternalId"]
        e.data["Account"] = pageSettings["AccountExternalId"]
        setNewItemIndex(newItemIndex + 1)
    }, [newItemIndex]);

    const enableDisableEditing = useCallback(() => {
        if (readOnly) {
            setGridCustomization(cl.enableDisableDataGridEditing(gridCustomization, gridInstance.current.instance()))
            setReadOnly(!readOnly)
        } else {
            setGridCustomization(cl.enableDisableDataGridEditing(gridCustomization, gridInstance.current.instance()))
            setReadOnly(!readOnly)
        }
    }, [gridCustomization, readOnly])

    const autoGenerateTransactions = () => {
        if (readOnly) return alert("Please enable editing to perform this action.", "Warning!");

        if (pageSettings["Completed"]) return alert("Cannot add transactions once the bank loan is marked as completed.", "Warning!")
        setAutoGenerateTransactionSettings({
            ...autoGenerateTransactionSettings,
            show: true
        })
    }

    const generateTransactions = useCallback((data) => {
        let count = transactionData.length + 1
        let firstDate = data.StartDate;
        let rows = data.NumberOfInstallments
        let gap = data.MonthGap
        let amount = data.Amount
        let principalAmount = data["PrincipalAmount"]
        let nwIndex = newItemIndex;
        for (let i = 0; i < rows; i++) {
            let month;
            if (i > 0) {
                month = (firstDate.getMonth() + gap);
                firstDate = new Date(firstDate.setMonth(month));
            }
            let newRecord = {
                ID: "NNNN",
                Date: new Date(firstDate),
                Amount: amount,
                Currency: pageSettings["CurrencyExternalId"],
                Remarks: "",
                externalId: "NNNN" + nwIndex,
                Account: pageSettings["AccountExternalId"],
                PrincipalAmount: principalAmount,
                TaxAmount: 0.0,
                Total: amount + principalAmount,
                Flag_Loan: true
            }
            transactionData.push(newRecord)
            editedData.push(newRecord)
            nwIndex++
            count++
        }
        setNewItemIndex(nwIndex)
        setTransactionData(transactionData)
        setEditedData(editedData)
        setChangesMade(true)
        gridInstance.current.instance().repaint()
        gridInstance.current.instance().option("dataSource", transactionData)
    }, [editedData, transactionData, gridCustomization])

    //#endregion

    const generatePropertyStatus = e => {
        if (e["PurchasePaymentPlan"]) { //Payment Plan
            return (<label key={props.key} className="form-check-label fs-4 fw-bold " htmlFor="ps-na"><span
                className="status-color na"></span>{e["PropertyStatus"]}</label>)
        } else if (!e["Available"]) { //Not Available
            return (<label key={props.key} className="form-check-label fs-4 fw-bold " htmlFor="ps-unoccupied"><span
                className="status-color unoccupied"></span>{e["PropertyStatus"]}</label>)
        } else if (!e["Occupied"]) { //Unoccupied
            return (<label key={props.key} className="form-check-label fs-4 fw-bold " htmlFor="ps-overdue"><span
                className="status-color overdue"></span>{e["PropertyStatus"]}</label>)
        } else if (e["Occupied"]) {//Occupied
            return (<label key={props.key} className="form-check-label fs-4 fw-bold " htmlFor="ps-occupied"><span
                className="status-color occupied"></span>{e["PropertyStatus"]}</label>)
        }
    }

    const saveChanges = () => {
        LoaderService.setData(true)
        let formData = new FormData()
        formData.append("BankLoan", pageSettings.externalId)
        formData.append("SpanString", spanString)
        formData.append("Transactions", JSON.stringify(editedData))
        formData.append("DeletedTransactions", JSON.stringify(deletedTransactions))
        apiClient
            .post('/BankLoan/AddUpdateBankLoanTransactions', formData)
            .then(response => {
                if (response) {
                    try {
                        LoaderService.setData(false)
                        let resp = JSON.parse(response.data)
                        setEditedData([])
                        setChangesMade(false)
                        setDeletedTransactions([])
                        if (resp[0].response) {
                            getData(true)
                        } else {
                            return alert(resp[0].message, 'Warning!')
                        }
                    } catch (e) {
                        LoaderService.setData(false)
                        return alert(response.data, 'Error!')
                    }
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    const exportGridData = () => {
        onExcelExporting(gridInstance.current.instance())
    }

    const backToPrevious = () => {
        navigate(-1);
    }

    return (
        <>
            <div
                className="d-flex flex-wrap flex-lg-nowrap justify-content-between align-items-center px-3 pt-3 bg-white border-bottom">
                <div className="d-flex align-items-center fs-5 mb-3">
                    <span className="text-secondary cursor-pointer"
                          onClick={() => navigate(-1)}>Bank Loans</span>
                    <Image src="/svg/chevron-left.svg" alt="chevron-left" width="20" height="20" className="mx-1"/>
                    <h2 className="fs-5 fw-medium mb-0 flex-shrink-0 me-4">Bank Loan Transactions</h2>
                </div>
                <div className="d-flex flex-wrap flex-xl-nowrap mb-3">
                    <Button variant="outline-primary" className="mx-2 px-3" onClick={exportGridData}>Export All
                        Data</Button>
                </div>
            </div>
            <div className="main-wrapper p-3">
                <Card className="p-3 border-0">
                    <div className="row mb-3">
                        <div className="col-sm-12 col-lg-4 mb-3 mb-lg-0">
                            <Card className="card-light p-3 border-0 text-center h-100">
                                <div className="fs-4 fw-bold mb-1">{pageSettings["DisplayAmount"]}</div>
                                <div className="text-secondary text-uppercase">Loan Approved Amount</div>
                            </Card>
                        </div>
                        <div className="col-md-12 col-lg-8">
                            <div className="row">
                                <div className="col-sm-6 col-md-4 mb-3 mb-md-0">
                                    <Card className="card-light p-3 border-0 text-center h-100">
                                        <div
                                            className="fs-4 fw-bold mb-1">{pageSettings["DisplayRemainingPrincipal"]}</div>
                                        <div className="text-secondary text-uppercase">Remaining Principal Amount</div>
                                    </Card>
                                </div>
                                <div className="col-sm-6 col-md-4 mb-3 mb-md-0">
                                    <Card className="card-light p-3 border-0 text-center h-100">
                                        <div
                                            className="fs-4 fw-bold mb-1 text-capitalize">{pageSettings["DisplayTotalInterest"]}</div>
                                        <div className="text-secondary text-uppercase">Total Interest</div>
                                    </Card>
                                </div>
                                <div className="col-sm-6 col-md-4 mb-3 mb-md-0">
                                    <Card className="card-light p-3 border-0 text-center h-100">
                                        <div
                                            className="fs-4 fw-bold mb-1 text-capitalize">{pageSettings["DisplayStartDate"]}</div>
                                        <div className="text-secondary text-uppercase">Start Date</div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rounded p-3 border border-secondary">
                        <div
                            className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mb-2">
                            <div className="d-sm-flex align-items-center justify-content-between">
                                <Button
                                    variant="outline-primary"
                                    className="flex-shrink-0 me-3"
                                    onClick={backToPrevious}
                                >
                                    <Image src="/svg/chevron-left-green.svg"
                                           alt="refresh" width="20"
                                           height="20"/>
                                    Back to Previous
                                </Button>
                            </div>
                            <div className="d-flex">
                                <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                        onClick={enableDisableEditing}>
                                    {readOnly ? "Enable Edit" : "Disable Edit"}
                                </Button>
                                <Button variant={changesMade ? "primary" : "outline-primary"}
                                        className="flex-shrink-0 me-3"
                                        disabled={!changesMade}
                                        onClick={saveChanges}>
                                    Save Data
                                </Button>
                                <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                        onClick={autoGenerateTransactions}>
                                    Auto Generate Transactions
                                </Button>
                                <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                        onClick={addTransaction}>
                                    Add
                                </Button>
                                <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                        onClick={clearFilter}>
                                    Clear Filter
                                </Button>
                                <InputGroup className="me-3 search-input">
                                    <TextBox
                                        ref={searchRef}
                                        placeholder="Search Transactions..."
                                        mode="search"
                                        inputAttr={{class: "form-control temp"}}
                                        elementAttr={{class: "search-input input-group"}}
                                        width="100%"
                                        onValueChanged={searchTransactionByText}
                                    ></TextBox>
                                </InputGroup>
                            </div>
                        </div>
                        <TransactionsComponent
                            ref={gridInstance}
                            data={transactionData}
                            columns={transactionColumns}
                            gridCustomization={gridCustomization}
                            height={500}
                            income={false}
                            expense={false}
                            purchasePayment={true}
                            deletePurchasePaymentTransaction={(e) => deleteTransaction(e)}
                            rowValidatingEvent={rowValidating}
                            summaryObject={{}}
                            newRowAdded={initRow}
                            isUpdated={() => getData(true)}
                        ></TransactionsComponent>
                    </div>
                </Card>
            </div>
            <AutoGenerateTransactions
                show={autoGenerateTransactionSettings.show}
                showInterestField={true}
                handleClose={() => setAutoGenerateTransactionSettings({
                    ...autoGenerateTransactionSettings,
                    show: false
                })}
                isUpdated={(data) => generateTransactions(data)}
            ></AutoGenerateTransactions>
        </>
    );
};

export default connect(mapStateToProps)(BankLoanTransactions);
